import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {useHistory } from "react-router-dom";
import styled from "styled-components";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NotverifiedModal({open, setOpen}) {
    const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">Email not verified</DialogTitle>
        <hr style={{margin: '0vh 1vw'}}/>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please verify your email to login.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const Button = styled.button`
 width: 20%;
height: 5.63vh;
left: 33.82vw;
top: 47.18vh;
border:none;
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 19px;
line-height: 3.5vh;
text-align: center;
margin-bottom: 2.43vh;

color: #FFFFFF;


background: #5DB0D8;
border-radius: 16px;
// margin-left: -18.5vw;
`
